import { forwardRef } from 'react'

import { type PromotionType } from '@onr/schema'
import { type Except } from 'type-fest'

import { type ZodFormProviderProps, ZodFormSubmitProvider } from '@/components/atoms/Form/ZodFormSubmitProvider'

import { createPromotionFormZod } from './PromotionFormZod'

export type PromotionFormProviderProps = Except<
  ZodFormProviderProps<ReturnType<typeof createPromotionFormZod>>,
  'schema'
> & {
  promotionType?: PromotionType
}

export const PromotionFormProvider = forwardRef<HTMLFormElement, PromotionFormProviderProps>(
  ({ children, promotionType, ...props }, ref) => (
    <ZodFormSubmitProvider schema={createPromotionFormZod(promotionType)} ref={ref} {...props}>
      {children}
    </ZodFormSubmitProvider>
  )
)
